import React from 'react';
import { useMediaQuery } from 'react-responsive';

const HeaderWallInvisibleMobile = () => {
  const isMobileRange = useMediaQuery({ minWidth: 200, maxWidth: 1024 });

  return !isMobileRange ? <div className='Wall'></div> : null;
};

export default HeaderWallInvisibleMobile;
